import { render, staticRenderFns } from "./accountsReceiveData.vue?vue&type=template&id=48a81327&scoped=true&"
import script from "./accountsReceiveData.vue?vue&type=script&lang=js&"
export * from "./accountsReceiveData.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceiveData.vue?vue&type=style&index=0&id=48a81327&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a81327",
  null
  
)

export default component.exports